export default class {
  resetInput () {
    if (!this.input) return
    if (!this.input.reset) return
    this.input.reset()
  }
  async checkForm () {
    let isOk = false
    await new Promise(resolve => {
      this.$refs.form.validate(async valid => {
        if (valid) {
          isOk = true
        }
        resolve()
      })
    })
    return isOk
  }
}
